export default {
      id: "icon--groups-usage",
      viewBox: "0 0 22.8 19.1",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--groups-usage",
      toString: function () {
        return this.url;
      }
    }